import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageShell, { Section } from "@/components/PageShell";

const About = () => (
  <PageShell
    eyebrow="// Company"
    title="About GigAfloat"
    subtitle="Building financial flexibility for the people who keep the world moving."
    testid="about-page"
  >
    <Section>
      <p>
        Millions of Americans rely on gig work to support themselves and their families. Yet traditional financial products often fail to serve independent workers whose income may vary from week to week.
      </p>
    </Section>

    <Section title="Our mission">
      <p className="text-white/85">
        Help gig workers access financial support when life happens.
      </p>
      <p>
        We're building tools designed specifically for independent workers, including rideshare drivers, delivery drivers, shoppers, and other members of the growing gig economy.
      </p>
      <p>
        GigAfloat is currently in development and gathering feedback from workers across the country to help shape future products and services.
      </p>
    </Section>

    <Section title="Join us">
      <p>
        Join our waitlist to help build the future of financial support for gig workers.
      </p>
      <Link
        to="/"
        className="mt-3 inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-6 py-3 rounded-full btn-glow"
        data-testid="about-cta"
      >
        Join the Waitlist <ArrowRight className="w-4 h-4" />
      </Link>
    </Section>
  </PageShell>
);

export default About;
